import React, {createContext, useContext, useEffect, useState} from 'react';
import defaultConfig from './defaultConfig';
import PropTypes from 'prop-types';

const LayoutContext = createContext();
const LayoutActionsContext = createContext();

export const useLayoutContext = () => useContext(LayoutContext);

export const useLayoutActionsContext = () => useContext(LayoutActionsContext);

const LayoutContextProvider = ({children}) => {
  const [layoutType, updateLayoutType] = useState(
    localStorage.getItem('layoutType')
      ? localStorage.getItem('layoutType')
      : defaultConfig.layoutType,
  );

  const [navStyle, updateNavStyle] = useState(
    localStorage.getItem('navStyle')
      ? localStorage.getItem('navStyle')
      : defaultConfig.navStyle,
  );

  const [direction, updateDirection] = useState(
    localStorage.getItem('direction')
      ? localStorage.getItem('direction')
      : defaultConfig.direction,
  );

  const [footerType, setFooterType] = useState(
    localStorage.getItem('footerType')
      ? localStorage.getItem('footerType')
      : defaultConfig.footerType,
  );

  const [footer, setFooter] = useState(
    localStorage.getItem('enableFooter')
      ? localStorage.getItem('enableFooter') === 'true'
      : defaultConfig.footer,
  );

  useEffect(() => {
    localStorage.setItem('layoutType', layoutType);
  }, [layoutType]);

  useEffect(() => {
    localStorage.setItem('navStyle', navStyle);
  }, [navStyle]);

  useEffect(() => {
    localStorage.setItem('direction', direction);
  }, [direction]);

  useEffect(() => {
    localStorage.setItem('footerType', footerType);
  }, [footerType]);

  useEffect(() => {
    localStorage.setItem('enableFooter', footer);
  }, [footer]);

  return (
    <LayoutContext.Provider
      value={{
        navStyle,
        direction,
        footerType,
        footer,
        layoutType,
        rtlLocale: defaultConfig.rtlLocale,
      }}>
      <LayoutActionsContext.Provider
        value={{
          setFooter,
          setFooterType,
          updateDirection,
          updateNavStyle,
          updateLayoutType,
        }}>
        {children}
      </LayoutActionsContext.Provider>
    </LayoutContext.Provider>
  );
};

export default LayoutContextProvider;

LayoutContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
